import { variousFormatter } from './various';

export function stateFormatter(abbreviate = false) {
  return data => {
    const states: string[] =
      typeof data.value === 'object' ? data.value : [data.value];

    return variousFormatter(abbreviate)({ value: states });
  };
}
